import { useEffect, useState } from 'react';

/**
 * useResponsivePlateWidth — returns a pixel width tailored to the current
 * viewport so PlateVisual (which uses fixed inline styles) doesn't overflow
 * on small screens.
 */
export default function useResponsivePlateWidth({ mobile = 150, tablet = 240, desktop = 300 } = {}) {
  const [w, setW] = useState(desktop);

  useEffect(() => {
    const compute = () => {
      const vw = window.innerWidth;
      if (vw < 640) setW(mobile);
      else if (vw < 1024) setW(tablet);
      else setW(desktop);
    };
    compute();
    window.addEventListener('resize', compute);
    return () => window.removeEventListener('resize', compute);
  }, [mobile, tablet, desktop]);

  return w;
}
